<template>
  <div
    class="mainBox wow animate__animated animate__fadeIn"
    style="min-height: 100vh"
  >
    <div class="newsTitle">{{ newsInfo.newsTitle }}</div>
    <div class="subTitle">{{ newsInfo.newsSubTitle }}</div>
    <div class="subTitle">{{ newsInfo.createTime?.split(" ")[0] }}</div>
    <!-- 富文本 -->
    <div
      v-html="newsInfo.newsDetail"
      class="richTextCl"
      style="margin-top: 2rem; background-color: none"
    ></div>
  </div>

  <div class="mainBox wow animate__animated animate__fadeIn">
    <div class="title" style="text-align: center">
      <div class="text1">更多新闻</div>
    </div>
    <div class="mewsList">
      <div
        class="mewsItem maria"
        v-for="(item, index) in moreNewsList"
        :key="index"
        @click="navTo('/news/detail', { id: item.id })"
      >
        <OssImg class="newsImg" fit="cover" :src="item.newsOssUrl"></OssImg>
        <div class="mewsItemInfo">
          <div class="ellipsis-multiline" style="-webkit-line-clamp: 2">
            {{ item.newsTitle }}
          </div>
          <div>{{ item.createTime?.substring(0, 10) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, watch, watchEffect } from "vue";
import { navTo } from "@/utils/util";
import NewsApi from "@/api/newsApi";
import { useRoute } from "vue-router";
import { processRichTextImages } from "@/utils/hanldeRichText";
const route = useRoute();
const newsApi = new NewsApi();
const newsInfo = ref({});
const moreNewsList = ref([]);
const id = ref();

// Fetch data function
const fetchData = async (id) => {
  await getDetail(id);
  await getMoreNews(id);
};

onMounted(() => {
  id.value = route.query.id;
  fetchData(route.query.id);
  addNewsBrowse(id.value);
});

// Watch for route.query.id changes
watch(
  () => route.query.id,
  (newId, oldId) => {
    if (newId && newId !== oldId) {
      id.value = newId;
      fetchData(newId);
    }
  }
);

/**
 * 获取详情信息
 */
const getDetail = async (id) => {
  let res = await newsApi.getNewsDetail(id);
  newsInfo.value = res;
  newsInfo.value.newsDetail = removeBackgroundColorsFromRichText(
    newsInfo.value.newsDetail
  );
  newsInfo.value.newsDetail = await processRichTextImages(
    newsInfo.value.newsDetail
  );
};

/**
 * 案例浏览量增加
 */
const addNewsBrowse = async (id) => {
  await newsApi.addNewsBrowse(id);
};

function removeBackgroundColorsFromRichText(richText) {
  // 创建一个临时div来解析HTML
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = richText;

  // 移除所有元素的style属性中的背景色
  const elementsWithStyle = tempDiv.querySelectorAll("[style]");
  elementsWithStyle.forEach((el) => {
    const style = el.getAttribute("style");
    const newStyle = style
      .replace(/background-color\s*:[^;]+;?/gi, "")
      .replace(/background\s*:[^;]+;?/gi, "")
      .trim();

    if (newStyle) {
      el.setAttribute("style", newStyle);
    } else {
      el.removeAttribute("style");
    }
  });

  // 移除内联样式中的背景色
  const allElements = tempDiv.querySelectorAll("*");
  allElements.forEach((el) => {
    if (el.style.backgroundColor || el.style.background) {
      el.style.backgroundColor = "";
      el.style.background = "";
    }
  });

  return tempDiv.innerHTML;
}
/**
 * 更多新闻
 */
const getMoreNews = async (id) => {
  let res = await newsApi.getNewsList({
    id: id,
  });
  moreNewsList.value = res.rows.slice(0, 4) || [];
};
</script>

<style lang="scss" scoped>
.newsContent {
  color: #424242;
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 2.125rem;
  margin-bottom: 2rem;
  text-indent: 2em;
}

.mewsList {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;
  margin-bottom: 3.5rem;

  .mewsItem {
    height: 22.25rem;
    border-radius: 1rem;
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .newsImg {
      width: 100%;
      height: 13.75rem;
      object-fit: cover;
      border-radius: 1rem 1rem 0 0;
    }

    .mewsItemInfo {
      width: 100%;
      flex: 1;
      padding: 1rem;
      box-sizing: border-box;
      text-align: justify;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      > div:first-of-type {
        font-size: 1.3rem;
        line-height: 2.125rem;
        font-weight: 600;
        font-family: "PingFang SC";
        color: #424242;
      }

      > div:nth-child(2) {
        font-size: 0.875rem;
        line-height: 1.25rem;
        font-weight: 500;
        font-family: "PingFang SC";
        color: #888888;
      }
    }
  }
}

.newsTitle {
  text-align: center;
  color: #212121;
  font-weight: 600;
  font-size: 3rem;
  line-height: 5.625rem;
  margin-bottom: 2rem;
  margin-top: 2rem;
}

.subTitle {
  text-align: left;
  color: #212121;
  font-weight: 500;
  font-size: 1.2rem;
}

// @media(max-width: 768px) {
//   .mewsList {
//     grid-template-columns: repeat(2, 1fr);
//     padding: 0 1rem;
//     box-sizing: border-box;
//   }
// }
</style>
